class StickyAddToCart extends HTMLElement {
  constructor() {
    super();
    this.stickyAtc = this.querySelector('.sticky-atc');
    this.isStickyAtcVisible = false;

    this.sectionId = this.dataset.sectionId;
    this.template = document.querySelector(`#ProductInfo-${this.sectionId}`);

    this.productQuantity = this.template.querySelector('.quantity__input');
    this.productForm = this.template.querySelector('product-form');

    this.quantity = this.querySelector('.quantity__input');
    this.button = this.querySelector('.sticky-atc__submit');

    this.quantity.addEventListener('change', this.onQuantityChange.bind(this));

    this.button.addEventListener('click', this.onButtonClick.bind(this));
  }

  onQuantityChange() {
    this.productQuantity.value = this.quantity.value;
  }

  onButtonClick() {
    this.productForm.submitButton.click();
  }

  connectedCallback() {
    document.addEventListener('scroll', this.toggleStickyAtc.bind(this));
    window.addEventListener('resize', this.toggleStickyAtc.bind(this));
    this.toggleStickyAtc();
  }

  disconnectedCallback() {
    document.removeEventListener('scroll', this.toggleStickyAtc.bind(this));
    window.removeEventListener('resize', this.toggleStickyAtc.bind(this));
  }

  toggleStickyAtc() {
    const productInfo = document.querySelector('.product-form__buttons');
    const rect = productInfo.getBoundingClientRect();
    const belowFold = rect.bottom < 0;

    if (belowFold && !this.isStickyAtcVisible) {
      this.stickyAtc.style.display = 'flex';
      this.isStickyAtcVisible = true;
    } else if (!belowFold && this.isStickyAtcVisible) {
      this.stickyAtc.style.display = 'none';
      this.isStickyAtcVisible = false;
    }
  }
}

customElements.define('sticky-add-to-cart', StickyAddToCart);
